/**
 * Normalize stored reminder/demo timing strings (often Ruby-ish / RFC-like)
 * into something `Date` can parse reliably.
 */
export const sanitizeReminderTiming = value => {
  if (value == null || value === '') return '';

  let sanitized = String(value);
  sanitized = sanitized.replace(/^[A-Za-z]{3},\s*/, '');
  sanitized = sanitized.replace(/,/g, '');
  sanitized = sanitized.replace(/(\s)(\d):/, '$10$2:');
  sanitized = sanitized.replace(/:(\d)(\s)/, ':0$1$2');
  sanitized = sanitized.replace(/:(\d):/, ':0$1:');
  sanitized = sanitized.replace(/\+(\d{2})(\d{2})$/, '+$1:$2');
  return sanitized;
};

/**
 * Parse a stored calendar_timings / demo_timing value into a Date.
 * @returns {Date|null}
 */
export const parseReminderTiming = value => {
  if (value == null || value === '') return null;

  try {
    const sanitized = sanitizeReminderTiming(value);
    const parsed = new Date(sanitized);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const fallback = new Date(String(value).replace(/,/g, ''));
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  } catch (e) {
    return null;
  }
};
